let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9fY0H")).then(() => parcelRequire('7loXx'));